import axios from "axios";

const state = {
    user: null,
    loggedOut: false,
    loggingOut: false,
    roles: [],
    orders: {},
    accountinfo:{},
    orderinfo:{},
    releaseorders:{},
    openinvoices:{},
    closeinvoices:{},
	productinfo:{},
	recentproduct:{},
	similarproduct:{},
	addcart:{},
	saveaddress:{},
	getaddress:{},
	getshippingrate:{}
};

const getters = {
    user: state => state.user,
    isLoggedOut: state => state.loggedOut,
    isLoggingOut: state => state.loggingOut,
    roles: state => state.roles,
    orders: state => state.orders,
    orderinfo: state => state.orderinfo,
    accountinfo: state => state.accountinfo,
    releaseorders: state => state.releaseorders,
    openinvoices: state => state.openinvoices,
    closeinvoices: state => state.closeinvoices,
	productinfo: state => state.productinfo,
	recentproduct:state=>state.recentproduct,
	similarproduct:state=>state.similarproduct,
	addcart:state=>state.addcart,
	saveaddress:state=>state.saveaddress,
	getaddress:state=>state.getaddress,
	getshippingrate:state =>state.getshippingrate
};

const actions = {
    /**
     * Registers the new User.
     *
     * @param {Function} commit
     * @param {Form} form
     * @return {Promise}
     */
    registerRequest({ commit }, {form }) {
        return form.post(`/shop/api/auth/register`).then(response => {
            commit("USER_REGISTERED", response.data);

            return response;
        });
    },
    onlineFormRequest({ commit }, form) {
        return axios.post(`/shop/api/auth/online-form-register`, form, {headers: { 'content-type': 'multipart/form-data' }})
        .then(response => {
            return response;
        });
    },
    /**
     * Logs the user in to the application.
     *
     * @param {Function} commit
     * @param {Form} form
     * @return {Promise}
     */
    login({ commit }, form) {
        return form.post(`/shop/api/auth/login`).then(response => {
            commit("USER_AUTHENTICATED", response.data);

            return response;
        });
    },
    forgotPassword({ commit }, form) {
        return form.post(`/shop/api/auth/forgotpassword`).then(response => {
            commit("USER_AUTHENTICATED", response.data);

            return response;
        });
    },

    /**
     * Logs the user out of the application.
     *
     * @param commit
     * @param form
     * @returns {Promise}
     */
    logout({ commit }, form) {
        commit("USER_LOGGING_OUT");

        return form.delete(`/shop/api/auth/logout`).then(response => {
            commit("USER_LOGGED_OUT");

            return response;
        });
    },

    logoutChild({ commit }, form) {
        return form.post(`/shop/api/user/logout`).then(response => {
            commit("USER_AUTHENTICATED", response); //Reset User to previous

            return response;
        });
    },

    /**
     * Marks the user as logging out on the state.
     *
     * @param commit
     * @returns {void}
     */
    loggingOut({ commit }) {
        commit("USER_LOGGING_OUT");
    },

    /**
     * Marks the user as logged out on the state.
     *
     * @param commit
     * @param state
     * @returns {void}
     */
    loggedOut({ commit, state }) {
        if (state.loggingOut) {
            return;
        }

        commit("USER_LOGGED_OUT");
    },

    /**
     * Loads the authenticated user from the backend.
     *
     * @param {Function} commit
     * @param {Object} data
     * @return {Promise}
     */
    setUserData({ commit }, data) {
        if (data && data.hasOwnProperty("user")) {
            commit("USER_AUTHENTICATED", data);
        } else {
            commit("USER_UNAUTHORIZED");
        }
    },

    resetPassword({ commit }, form) {
        return form
            .put(`/shop/api/users/reset-password/${state.user.id}`)
            .then(response => {
                return response;
            });
    },

    newPassword({ commit }, { token, form }) {
        return form.put(`/shop/api/auth/new-password/${token}`).then(response => {
            return response;
        });
    },

    loadRoles({ commit }) {
        return axios.get(`/shop/api/roles`).then(response => {
            commit("USER_ROLES_LOADED", response.data);

            return response;
        });
    },

    changeSettings({ commit }, form) {
        return form
            .put(`/shop/api/users/change-settings/${state.user.id}`)
            .then(response => {
                return response;
            });
    },
    
    loadAccountInfo({ commit }) {
        return axios.get(`/shop/api/account/info/${state.user.accountnumber}`).then(response => {
            commit("USER_ACCOUNTINFO_LOADED", response.data);

            return response;
        });
    },

    loadOrders({ commit },{page}) {
        return axios.get(`/shop/api/account/orders/${state.user.accountnumber}?page=${page}`).then(response => {
            return response;
        });
    },

    loadSFAOrders({ commit },{page}) {
        return axios.get(`/shop/api/account/release-orders/${state.user.accountnumber}?page=${page}`).then(response => {
            commit("USER_RELEASEORDERS_LOADED", response.data);

            return response;
        });
    },

    loadOrderInfo({ commit },salesid) {
        return axios.get(`/shop/api/account/order-info/${salesid}/${state.user.accountnumber}`).then(response => {
            commit("USER_ORDERINFO_LOADED", response.data);

            return response;
        });
    },
	
	loadOrderPDF({ commit },salesid) {
       return axios.get(`/shop/api/order-pdf/${salesid}/${state.user.accountnumber}`,{
            responseType: 'blob',
        }).then(response => {
            return response;
        });
    },

    loadOpenInvoices({ commit }) {
        return axios.get(`/shop/api/account/open-invoices/${state.user.accountnumber}`).then(response => {
            commit("USER_OPENINVOICE_LOADED", response.data);

            return response;
        });
    },

    loadCloseInvoices({ commit },{seldate}) {
        return axios.get(`/shop/api/account/closed-invoice/${state.user.accountnumber}?seldate=${seldate}`).then(response => {
            commit("USER_CLOSEINVOICE_LOADED", response.data);

            return response;
        });
    },

    ApproveHoldOrder({ commit }, {form , salesid}) {
        return form.post(`/shop/api/account/holdorder/${salesid}`).then(response => {
            commit("SFA_ORDER_APPROVE", response.data);

            return response;
        });
    },

    CancelHoldOrder({ commit },  {salesid}) {
        return axios.put(`/shop/api/account/cancelholdorder/${salesid}/${state.user.accountnumber}`).then(response => {
            return response;
        });
    },

    updateSalesOrderAddress({ commit }, {form , salesid}) {
        return form.post(`/shop/api/account/updateholdorderaddress/${salesid}`).then(response => {
            return response;
        });
    },

	loadProductInfo({ commit },{itemid, inventcolorid}) {
        return axios.get(`/shop/api/product-info/${itemid}/${inventcolorid}`).then(response => {
            commit("USER_PRODUCTINFO_LOADED", response.data);

            return response;
        });
    },
	loadRecentProduct({ commit },{itemid, inventcolorid, customer_id}) {
        return axios.get(`/shop/api/recent-products/${itemid}/${inventcolorid}/${customer_id}`).then(response => {
            commit("USER_RECENTPRODUCT_LOADED", response.data);

            return response;
        });
    },
	loadSimilarProduct({ commit },{itemid, inventcolorid}) {
        return axios.get(`/shop/api/similar-products/${itemid}/${inventcolorid}`).then(response => {
            commit("USER_SIMILARPRODUCT_LOADED", response.data);

            return response;
        });
    },
	AddtoCart({ commit }, {form}) {
        return form.post(`/shop/api/cart/addcart`).then(response => {
            commit("ADD_TO_CART", response.data);

            return response;
        });
    },
    AddtoCartSample({ commit }, {form}) {
        return form.post(`/shop/api/cart/addcartsample`).then(response => {
            commit("ADD_TO_CART", response.data);

            return response;
        });
    },
    updateCDICart({ commit }, {form}) {
        return form.post(`/shop/api/cart/updatecdicart`).then(response => {
            commit("ADD_TO_CART", response.data);
            return response;
        });
    },
	loadSaveAddress({ commit }) {
        return axios.get(`/shop/api/account/save-address/${state.user.accountnumber}`).then(response => {
            commit("USER_SAVEADDRESS_LOADED", response.data);

            return response;
        });
    },
	
	loadSelectedAddress({ commit },addressid) { 
        return axios.get(`/shop/api/account/get-address/${state.user.accountnumber}/${addressid}`).then(response => {
            commit("USER_GETADDRESS_LOADED", response.data);

            return response;
        });
    },
	loadShipping({ commit },obj) {
        return axios.get(`/shop/api/getshipping/${state.user.accountnumber}?shipping_method=${obj.shipping_method}&total=${obj.total}&oneflat=${obj.oneflat}&ship_address=${obj.ship_address}&ship_city=${obj.ship_city}&ship_state=${obj.ship_state}&ship_country=${obj.ship_country}&ship_postal=${obj.ship_postal}&isresidential=${obj.isresidential}`).then(response => {
            commit("GET_SHIPPING_RATE", response.data);

            return response;
        });
    },
    
    contactRequest({ commit }, {form }) {
        return form.post(`/shop/api/contact`).then(response => {
            return response;
        });
    },

    loadImpersonateAccount({ commit }, { form }) {
        return axios.get(`/shop/api/impersonateaccount?searchaccount=${form.searchaccount}&page=${form.page}`).then(response => {
            return response;
        });
    },
    
    loadImpersonateAccountLogin({ commit }, user_id) {
        return axios.post(`/shop/api/loggedmein`,{id: user_id}).then(response => {
            commit("USER_AUTHENTICATED", response);
            return response;
        });
    },
};

const mutations = {
    /**
     * Sets the guest user data.
     *
     * @param {Object} state
     * @return {void}
     */
    USER_UNAUTHORIZED: state => {
        state.user = { id: 0 };
    },

    /**
     * Sets the current attribute on the state.
     *
     * @param {Object} state
     * @param {Object} data
     * @return {void}
     */
    USER_AUTHENTICATED: (state, data) => {
        if (data.hasOwnProperty("user")) {
            state.user = data.user;
        } else {
            state.user = data.data;
        }

        if (state.social) {
            state.social = null;
        }
    },

    /**
     * Sets the Logging Out phase on the state.
     *
     * @param {Object} state
     * @return {void}
     */
    USER_LOGGING_OUT: state => {
        state.loggingOut = true;
    },

    /**
     * Sets the Logged Out phase on the state.
     *
     * @param {Object} state
     * @return {void}
     */
    USER_LOGGED_OUT: state => {
        state.loggedOut = true;
        state.user = { id: 0 };
    },

    USER_ROLES_LOADED: (state, data) => {
        if (state.roles === null) {
            state.roles = data;
        } else {
            state.roles = state.roles.concat(data);
        }
    },

    USER_REGISTERED: (state, data) => {
        state.user = data;
    },

    USER_ACCOUNTINFO_LOADED: (state, data) => {
        state.accountinfo = data;
    },

    USER_ORDERS_LOADED: (state, data) => {
        state.orders = data;
    },

    USER_ORDERINFO_LOADED: (state, data) => {
        state.orderinfo = data;
    },

    USER_RELEASEORDERS_LOADED: (state, data) => {
        state.releaseorders = data;
    },

    USER_OPENINVOICE_LOADED: (state, data) => {
        state.openinvoices = data;
    },

    USER_CLOSEINVOICE_LOADED: (state, data) => {
        state.closeinvoices = data;
    },
	USER_PRODUCTINFO_LOADED: (state, data) => {
        state.productinfo = data;
    },
	USER_RECENTPRODUCT_LOADED: (state, data) => {
        state.recentproduct = data;
    },
	USER_SIMILARPRODUCT_LOADED: (state, data) => {
        state.similarproduct = data;
    },
	ADD_TO_CART: (state, data) => {
        state.addcart = data;
    },
	
	USER_SAVEADDRESS_LOADED: (state, data) => {
        state.saveaddress = data;
    },
	USER_GETADDRESS_LOADED: (state, data) => {
        state.getaddress = data;
    },
	GET_SHIPPING_RATE: (state, data) => {
        state.getshippingrate = data;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};